import React from "react";
import { useNavigate } from "react-router-dom";

const ImageSlider = () => {
  const navigate = useNavigate();
  const handleClick = (gamesThumbnail, gamesUrl) => {
    localStorage.setItem("gameThumbnail", gamesThumbnail);
    localStorage.setItem("gameUrl", gamesUrl);
    navigate("../game-component1");
  };
  localStorage.removeItem("gameUrl");
  localStorage.removeItem("gameThumbnail");
  return (
    <div class="centered-slider-wrapper">
      <div className="slider-container">
        <div
          className="product-card"
          onClick={() =>
            handleClick(
              "assets/Icons/Great_Air_Battles.webp",
              "045.Great%20Air%20Battles/"
            )
          }
        >
          <img
            src="assets/Icons/Great_Air_Battles.webp"
            alt="Great-Air-Battles"
            style={{ borderRadius: "10px" }}
          />
        </div>
        <div
          className="product-card"
          onClick={() =>
            handleClick("assets/Icons/Mini-Racer.webp", "109.Mini%20Racer/")
          }
        >
          <img
            src="assets/Icons/Mini-Racer.webp"
            alt="Mini-Racer"
            style={{ borderRadius: "10px" }}
          />
        </div>
        <div
          className="product-card"
          onClick={() =>
            handleClick(
              "assets/Icons/Tractor-Mania.webp",
              "113.Tractor%20Mania/"
            )
          }
        >
          <img
            src="assets/Icons/Tractor-Mania.webp"
            alt="Tractor-Mania"
            style={{ borderRadius: "10px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageSlider;
